/**
 * CORE-1297 (возврат QA 09.09.2026, комната XIV61d) — что делает «ИСКЛЮЧИТЬ»,
 * когда причина не выбрана.
 *
 * До этой правки — ничего, и молча. Кнопка стояла `disabled={!reason}`, а
 * `submit` первой строкой делал `if (!reason || isSending) return;`. Выглядит
 * она при этом как обычная красная кнопка, только с прозрачностью 0.5, так что
 * нажатие читается как подтверждение: диалог не закрывается, запрос не уходит,
 * ошибки нет, подсказки «выберите причину» нет.
 *
 * Именно так и выглядел возврат: «ведущий открыл Участники → Удалить и
 * подтвердил действие, участник остался в эфире». Сверка с сервером показала,
 * что кика не было вовсе — ни `KickedAtUtc`, ни `room.participant_kicked`, ни
 * фронтового `user_kicked_from_room` (он пишется ТОЛЬКО после подтверждения
 * сервером, поэтому его отсутствие и означает «запрос не ушёл»). Последний
 * записанный на DEV кик к тому моменту был от 22.08.2026.
 *
 * Правило вынесено сюда, потому что jest в этом репозитории без DOM: модалку не
 * отрендерить, а «нажатие без причины обязано что-то сказать» — ровно то
 * поведение, отсутствие которого стоило тикету захода.
 */

export interface KickSubmitInput {
    /** Выбранная причина; `null` — не выбрана. */
    reason: string | null;
    /** Кик уже уходит: повторные нажатия игнорируются. */
    isSending: boolean;
}

export type KickSubmitAction =
    /** Ничего не делать — запрос уже в полёте. */
    | 'ignore'
    /** Причины нет: сказать об этом, а не молчать. */
    | 'ask-reason'
    /** Отправлять. */
    | 'send';

export function resolveKickSubmit({ reason, isSending }: KickSubmitInput): KickSubmitAction {
    if (isSending) return 'ignore';
    if (!reason) return 'ask-reason';
    return 'send';
}

/**
 * Кнопка блокируется ТОЛЬКО на время отправки. Отсутствие причины больше не
 * делает её немой мишенью: нажатие по ней объясняет, чего не хватает.
 */
export function kickSubmitDisabled({ isSending }: Pick<KickSubmitInput, 'isSending'>): boolean {
    return isSending;
}
